import BrokerBuyRouteController from '@/steps/CommercialCombined/BrokerBuyRouteController'

const BrokerBuy = () => {
  return (
    <>
      <BrokerBuyRouteController />
    </>
  )
}

export default BrokerBuy
